import React, { useState, useEffect } from 'react'
import '../styles/CalendarView.css'
import ActivityList from './ActivityList'
import ActivityDetails from './ActivityDetails'

function DateTile(props) {
	const isToday = props.isToday
	const cDate = props.date
	const cMonth = props.month
	const dateString = props.dateString
	const activities = props.activities
	const [events, setEvents] = useState([])
	const [areaHeight, setAreaHeight] = useState()
	const [backgroundColor, setBackgroundColor] = useState()
	const [textColor, setTextColor] = useState()
	const [showActivities, setShowActivities] = useState()
	const [showActivityDetails, setShowActivityDetails] = useState()

	const handleResize = () => {
		const dt = document.getElementsByClassName('date-tile')
		const dtHeight = dt[0].clientHeight
		const ah = dtHeight - 24
		setEventItems(ah)
		setAreaHeight(ah)
	}

	useEffect(() => {
		const dt = document.getElementsByClassName('date-tile');
		const dtHeight = dt[0].clientHeight
		const ah = dtHeight - 24
		setEventItems(ah)
		let bc
		let tc = "#ffffff"
		switch(props.status) {
			case 1: // current month
				bc = "#ffffff"
				tc = "#000000"
				break
			case 2: //"attention":
				bc = "#c96f6f"
				break
			case 3: // done
				bc = "#9d9d9d"
				break
			case 4: //"happening":
				bc = "#a9be3d"
				break
			case 5: //"upcoming":
				bc = "#ddbc33"
				break
			default:
				bc = "#f4f4f4"
				tc = "#646464"
		}
		setBackgroundColor(bc);
		setTextColor(tc);
		window.addEventListener('resize', handleResize)
		return(() => {
			window.removeEventListener('resize', handleResize)
		})
	}, [props.isCurrentMonth, props.activities])

	function setEventItems(ah) {
		const evs = []
		if(activities != null) {
			if(activities.length === 1) {
				evs.push(<div>{activities[0].activity_title.toUpperCase()}</div>)
			}
			else if(activities.length > 1) {
				evs.push(<div>{activities.length} ACTIVITIES</div>)
				evs.push(<div>SCHEDULED</div>)
			}
		}
		setEvents(evs)
	}

	return(<div className="date-tile calendar-grid-item" style={{background: backgroundColor}}>
		{isToday && <div className="dt-today"><div className="dt-date">{cDate}</div></div>}
		{!isToday && <div className="dt-not-today"><div className="dt-date"  style={{'color': textColor}}>{cDate}</div></div>}
		<div className="dt-event-area" id={"dt-" + cDate} onClick={(e) => {
				if(activities.length > 1) {
					setShowActivities(true)
				}
				else if(activities.length === 1) {
					setShowActivityDetails(true)
				}
			}} style={{height: areaHeight + "px", color: textColor}}>
			{events}
		</div>
		<ActivityList show={showActivities}
			status={props.status}
			hide={() => { setShowActivities(false)}}
			onSignal={(view, id) => { props.onSignal(view, id) }}
			cDate={cDate} cMonth={cMonth} dateString={dateString}
			activities={activities} />
		<ActivityDetails show={showActivityDetails}
			hide={() => { setShowActivityDetails(false) }}
			onSignal={(view, id, stat) => { props.onSignal(view, id, stat) }}
			data={activities[0]}
			dateString={dateString} />
	</div>)
}

export default DateTile
